export default function translate(i18n, propriete) {
  if (propriete === 'domiciliationBancaireId') return i18n.t('editLotPaiement.informations.banque');
  if (propriete === 'modeReglementId') return i18n.t('editLotPaiement.informations.modePaiement');
  if (propriete === 'dateRemise') return i18n.t('editLotPaiement.informations.datePaiement');
  if (propriete === '[0].dateMouvement') return i18n.t('editLotPaiement.informations.datePaiement');
  return propriete;
}
